import { ClockStarFourPointsOutlineIcon } from './ClockStarFourPointsOutlineIcon';

/**
 * author: Jeff Anders
 * id ECD839D8-3E3A-4080-AE28-E15A82E0ACF2
 * name clock-star-four-points-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clock-star-four-points-outline.svg
 * tags
 * - Date / Time 
 */
export const ClockAutoOutlineIcon = ClockStarFourPointsOutlineIcon;
export default ClockAutoOutlineIcon